import React from 'react';
import moment, { Moment } from 'moment';

import {
  WithStyles,
  withStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { DatePicker } from '@material-ui/pickers';

import { parseDateFromBookingDatePicker } from '../../../helpers/dateHelpers';

const styles = (theme: Theme) => createStyles({
  textCenter: {
    textAlign: 'center',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 'fit-content',
    whiteSpace: 'nowrap',
    flexShrink: 0, // Предотвращаем сжатие элемента
    // На мобильных: горизонтальное отображение без дня недели
    [theme.breakpoints.down(600)]: {
      flexDirection: 'row',
    },
  },
  dateText: {
    whiteSpace: 'nowrap',
    // Уменьшаем размер шрифта на мобильных
    [theme.breakpoints.down(600)]: {
      fontSize: '0.8125rem', // 13px для компактности
      lineHeight: 1.1,
    },
  },
  dayText: {
    whiteSpace: 'nowrap',
    // Скрываем день недели на мобильных
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
});

interface IProps extends WithStyles<typeof styles> {
  currentStatisticDate: string;
  handleChangeDate: (d: any) => void;
}

const BookingDatePicker: React.FC<IProps> = ({ classes, currentStatisticDate, handleChangeDate }) => {
  const date: {
    date: string;
    day?: string;
  } = parseDateFromBookingDatePicker(currentStatisticDate);

  return (
    <DatePicker
      autoOk
      variant="inline"
      value={moment(currentStatisticDate)}
      onChange={(date: Moment | null) => handleChangeDate(date && date.format())}
      TextFieldComponent={(props: any) => (
        <div
          ref={props.inputRef}
          className={classes.textCenter}
          onClick={props.onClick}
        >
          <Typography className={classes.dateText}>
            { date.date }
          </Typography>
          <Typography variant="caption" className={classes.dayText}>
            { `(${date.day})` }
          </Typography>
        </div>
      )}
    />
  );
};

export default withStyles(styles)(BookingDatePicker);
